import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import FloatingActions from "./FloatingActions";

const Layout = ({ children }) => {
    return (
        <div className="App flex flex-col min-h-screen">
            <Header />
            <main className="flex-1">{children}</main>
            <Footer />
            <FloatingActions />
        </div>
    );
};

export default Layout;
